import React from 'react'
import PropTypes from 'prop-types'
import BlockContent from '../shared/blockContent'

import './caseStudySection.css'

const CaseStudySection = ({ data }) => {
  return (
    <section className="caseStudySection">
      <h3>{data.title}</h3>
      <div className="content">
        <BlockContent input={data.content}></BlockContent>
      </div>
    </section>
  )
}

CaseStudySection.propTypes = {
  data: PropTypes.object,
}

export default CaseStudySection
